import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FiPhone } from 'react-icons/fi';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isMenuOpen]);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const navLinks = [
    { to: '/portfolio', label: 'Completed Projects' },
    { to: '/templates', label: 'Website Templates' },
    { to: '/pricing', label: 'Pricing' },
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Contact Us' }
  ];

  return (
    <>
      <header className={`sfm-header ${isScrolled ? 'sfm-header--scrolled' : ''}`}>
        <div className="sfm-header__container container">
          <Link to="/" className="sfm-header__logo">
            <img
              src="/images/silverfox-logo-mark.webp"
              alt="SilverFox Media"
              className="sfm-header__logo-image"
            />
            <span className="sfm-header__tagline">
              Web Development
              <span className="sfm-header__tagline-sep" aria-hidden="true">&middot;</span>
              Software
              <span className="sfm-header__tagline-sep" aria-hidden="true">&middot;</span>
              Data
              <span className="sfm-header__tagline-sep" aria-hidden="true">&middot;</span>
              Design
            </span>
          </Link>

          <div className="sfm-header__right">
            <a href="tel:9728008105" className="sfm-header__phone">
              <FiPhone />
              <span>(972) 800-8105</span>
            </a>

            <button
              className="sfm-header__hamburger"
              onClick={() => setIsMenuOpen(true)}
              aria-label="Open menu"
            >
              <span className="sfm-hamburger-line"></span>
              <span className="sfm-hamburger-line"></span>
              <span className="sfm-hamburger-line"></span>
            </button>
          </div>
        </div>
      </header>

      <div
        className={`sfm-menu-overlay ${isMenuOpen ? 'sfm-menu-overlay--active' : ''}`}
        onClick={closeMenu}
      ></div>

      <nav className={`sfm-slide-menu ${isMenuOpen ? 'sfm-slide-menu--open' : ''}`}>
        <button
          className="sfm-menu-close-btn"
          onClick={closeMenu}
          aria-label="Close menu"
        >
          <span className="sfm-close-icon"></span>
        </button>

        <ul className="sfm-menu-list">
          {navLinks.map((link) => (
            <li key={link.to} className="sfm-menu-item">
              <NavLink
                to={link.to}
                className="sfm-menu-link"
                onClick={closeMenu}
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="sfm-menu-cta-section">
          <Link to="/contact" className="sfm-menu-cta-btn sfm-menu-cta-contact" onClick={closeMenu}>
            Start Your Project
          </Link>
        </div>
      </nav>
    </>
  );
};

export default Header;
